import { useQuery } from "@apollo/client/react";
import { useIntl } from "react-intl";
import { AccessMembershipPolicyDocument } from "@/graphql/generated/operations";
import { Button } from "@/components/design/Button";

/** Read back the deployment configuration; this surface cannot edit assignment rules. */
export function AccessMembershipPolicyInfo() {
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id });
  const { data, loading, error, refetch } = useQuery(AccessMembershipPolicyDocument, { fetchPolicy: "network-only" });
  const domains = data?.accessMembershipPolicy.employeeEmailDomains;

  return <section id="groups-membership-policy" aria-label={t("admin.membershipPolicy.title")}
    className="space-y-3 text-smycles-body text-ink">
    <h3 className="font-medium text-ink">{t("admin.membershipPolicy.title")}</h3>
    {loading ? <p role="status">{t("common.loading")}</p>
      : error || !domains ? <div className="space-y-2">
        <p role="alert">{t("admin.membershipPolicy.unavailable")}</p>
        <Button id="groups-membership-policy-retry" variant="secondary" size="compact"
          onClick={() => void refetch().catch(() => undefined)}>{t("admin.roles.retry")}</Button>
      </div>
      : domains.length ? <div>
        <p>{t("admin.membershipPolicy.activeDomains")}</p>
        <ul aria-label={t("admin.membershipPolicy.activeDomains")} className="mt-2 space-y-1">
          {domains.map(domain => <li key={domain} className="break-words font-medium text-ink">{domain}</li>)}
        </ul>
      </div> : <p>{t("admin.membershipPolicy.disabled")}</p>}
    <p className="text-smycles-meta text-ink-muted">{t("admin.membershipPolicy.readOnly")}</p>
  </section>;
}
